/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isObject from 'lodash/isObject';

/**
 * Továrna na slajdy pro přehrávače obsahu.
 */
class ViewerSlideFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<ViewerSlide>} ViewerSlide Konstruktor pro slajdy.
   * @param {StateMachineFactory} stateMachineFactory
   * @returns {ViewerSlideFactory} Nová instance.
   */
  constructor(ViewerSlide, stateMachineFactory) {
    if (!isObject(ViewerSlide)) {
      throw new TypeError(`Invalid viewer slide constructor ${ViewerSlide}.`);
    }
    this.ViewerSlide = ViewerSlide;
    this.stateMachineFactory = stateMachineFactory;
  }

  /**
   * Vytvoří nový slajd pro přehrávače obsahu.
   * @param {HTMLElement} parentEl Rodičovský element, do kterého se vloží elementy slajdu.
   * @param {ScheduleInfo} scheduleInfo Informace o přehrání média, které má slajd přehrát.
   * @returns {ViewerSlide} Vytvořený slajd.
   */
  create(parentEl, scheduleInfo) {
    return new this.ViewerSlide(
      parentEl,
      scheduleInfo,
      this.stateMachineFactory
    );
  }
}

export default ViewerSlideFactory;
